import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import resources from './locales/resources'

export const defaultNS = 'common'

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: process.env.REACT_APP_DEBUG === 'true',
		resources,
		fallbackLng: 'fi',
		ns: ['common'],
		defaultNS,
		supportedLngs: ['fi', 'en'],
		returnNull: false,
		returnEmptyString: false,
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		react: {
			useSuspense: false,
		},
		detection: {
			order: ['querystring'],
		},
	})

export default i18n
